import React from 'react'

// local components
import EFSHeader from './EFSHeader'

const Header = props => {
  const { bhParam } = props

  return <>{bhParam === 'efs' && <EFSHeader />}</>
}

export default Header
